import {
  EnvironmentConfig,
  environmentDefaults,
  featureFlagDefaults,
  oidcEvernorthDefault,
} from '@cigna/chcp/shared/environment-util';

export const environment: EnvironmentConfig = {
  ...environmentDefaults('evernorth-provider'),
  authMethod: 'oidc',
  oidc: {
    ...oidcEvernorthDefault,
    clientId: 'evernorth_provider_spa_checkout_client',
    metadataUri:
      '/mga/sps/oauth/oauth20/metadata/evernorth_provider_spa_checkout_def',
    secureUris: [
      'https://p-chk-evernorth-provider.digitaledge.cigna.com',
      'https://p-chk-gsg.digitaledge.cigna.com',
      '/prv/secure',
    ],
  },
  auth0: {
    audience: '',
    clientId: '',
    connection: '',
    domain: '',
    scope: '',
    redirect_uri: '',
    secureUris: [],
    impersonationConnection: '',
    impersonationReturnTo: '',
  },
  redirect: {
    crossOrigin: {
      domain: 'https://chk-cignaforhcp.cigna.com',
    },
    resourceLibrary: 'https://chk.static.evernorth.com/',
  },
  api: {
    proxy: {
      headers: {
        accept: '*/*',
        content_type: 'application/json',
      },
    },
    gateways: {
      cdn: 'https://chk.static.evernorth.com/',
      resourceContent: 'https://p-chk-digital-static.digitaledge.cigna.com/',
      secureApi: 'https://p-chk-evernorth-provider.digitaledge.cigna.com',
      publicApi:
        'https://p-chk-evernorth-provider.digitaledge.cigna.com/public',
      gsgPublicApi: 'https://p-chk-gsg.digitaledge.cigna.com/public',
      gsgSecureApi: 'https://p-chk-gsg.digitaledge.cigna.com',
      graphql:
        'https://p-chk-evernorth-provider.digitaledge.cigna.com/apollo-graphql',
      privateLinkRouter: '', // todo: update
      publicLinkRouter: '', // todo: update
    },
    searchIndex: 'prodchk',
    salesDemo: false,
  },
  features: {
    ...featureFlagDefaults,
    nextRelease: false,
    patientEnhPower: false,
    claim360GA: false,
    enablePCM: false,
    hasCBHAmIInNetwork: false,
    cocePathwellPCLM: false,
  },
  launchDarklyClientId: '6627eacd01f25f101d225590',
  disabledRoutes: [],
};
